import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '../store';
import { StoreService } from '../store.service';
import { mergeMap, share, take } from 'rxjs/operators';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Product } from '../../product/product';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { EditStoreDialogueComponent } from '../store-management/edit-store-dialogue/edit-store-dialogue.component';
import { AdhesionRow } from '../../core/adhesion-row';

const ELEMENT_DATA: AdhesionRow[] = [
  {
    raison: "Frais d'adhésion",
    acheteur: '',
    standard: 'Gratuit',
    premium: '49.99$ / année',
  },
  {
    raison: 'Revenus',
    acheteur: '',
    standard: '60% des ventes',
    premium: '80% des ventes',
  },
  { raison: 'Commission*', acheteur: 'X', standard: '40%', premium: '20%' },
  {
    raison: 'Frais de vente par produit vendu',
    acheteur: '',
    standard:
      '0.30$ (produits de moins de 5 $)' +
      '0.20$ (produits entre 5$ et 10$)' +
      '0.10$ (produits de plus de 10$)',
    premium: 'aucuns frais',
  },
  {
    raison: 'Versements**',
    acheteur: '',
    standard: 'Tous les mois, sans solde minimum et sans frais',
    premium: 'Tous les mois, sans solde minimum et sans frais',
  },
  {
    raison: 'Téléversement de produits',
    acheteur: '',
    standard: 'Illimité',
    premium: 'Illimité',
  },
  {
    raison: 'Taille maximale par produit',
    acheteur: '',
    standard: '100 Mo',
    premium: '1 Go',
  },
];

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.scss'],
})
export class StoreComponent implements OnInit {
  store$: Observable<Store> | undefined = undefined;
  storeProducts$: Observable<Product[]> | undefined = undefined;
  addStoreForm: UntypedFormGroup = new UntypedFormGroup({
    store: new UntypedFormControl(''),
  });
  displayedColumns: string[] = ['raison', 'standard', 'premium'];
  dataSource = ELEMENT_DATA;
  submitted = false;

  constructor(
    private readonly storeService: StoreService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.getUserStore();
    this.storeProducts$ = this.getStoreProducts();
  }

  submitNewStore(): void {
    if (this.addStoreForm?.valid) {
      this.submitted = true;
      const productForm = this.addStoreForm.get('store')?.value;
      const newStore: Store = {
        name: productForm.name,
        description: productForm.description,
        image: productForm.imageInput,
        active: false,
      };
      this.createStore(newStore)
        .pipe(
          mergeMap(() => this.getUserStore()),
          take(1)
        )
        .subscribe(() => (this.submitted = false));
    }
  }

  addProduct(): void {
    this.storeProducts$ = this.getStoreProducts();
  }

  productDeleted(): void {
    this.storeProducts$ = this.getStoreProducts();
  }

  openEditDialogue(store: Store): void {
    const dialogRef = this.dialog.open(EditStoreDialogueComponent, {
      width: '500px',
      data: { store },
    });

    dialogRef.afterClosed().subscribe((result: Store) => {
      if (result) {
        this.getUserStore();
      }
    });
  }

  private getUserStore(): Observable<Store> {
    this.store$ = this.storeService.getUserStore().pipe(share());
    return this.store$;
  }

  private getStoreProducts(): Observable<Product[]> | undefined {
    if (this.store$) {
      return this.store$.pipe(
        mergeMap(() => this.storeService.getUserStoreProducts())
      );
    }
    return undefined;
  }

  private createStore(storeToCreate: Store): Observable<Store> {
    return this.storeService.addOne(storeToCreate);
  }
}
